import type { FaireProductEntity } from "../../entity_types/product";

export const p_v58xruvbv3: FaireProductEntity = {
  token: "p_v58xruvbv3",
  type: "product",
  name: "Classic Coconut Shampoo",
  brandToken: "b_m96b98ugs5",
  brandName: "California Naturals",
  imageUrl:
    "https://cdn.faire.com/fastly/db83bfef0f4cac38dc074104ea4b81aab70a48975925419a2519486dc53e2be0.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c66d143c2ed92e81da9c69dbbdf28ae830b1fe7bf8540a3fb2f2669cb9d8bff4.jpeg",
    "https://cdn.faire.com/fastly/0b28b3800ee66b7b89603a9973e3d7c6ac195903f45a51e38fb950f12c1d59b3.jpeg",
    "https://cdn.faire.com/fastly/9dc7c7f5b8d6704df9ff3b6728ca272377198d9a452d162ce162dc991e8c87c9.jpeg",
    "https://cdn.faire.com/fastly/15d0e0cc3d3a8742237be0dbbd39594950fac4acfeb5eab64125f46bce4ea1fc.jpeg",
    "https://cdn.faire.com/fastly/f6e71ae84b7c3afc4ba91b2c4f69cdc0acddb34aa73a565ad78879576dd2b8f1.jpeg",
    "https://cdn.faire.com/fastly/472b1a6e7e52629f1afbed6d6f2916f435f1ddb2eda1452c9c7260172461a0b9.png",
    "https://cdn.faire.com/fastly/a0dd941fba59cfbb5223a973038e04a09a7d38da0c61c7a260b89537bf374fd7.png",
    "https://cdn.faire.com/fastly/83aaf5ea01dddac18af69361b71ae8a8b40bf8a2ab87191008e78028cfd56550.png",
    "https://cdn.faire.com/fastly/5e62c5f1e64b735574e0cab7c48ec342eb4f4ffe2241def78abaab3be9eb06a5.jpeg",
    "https://cdn.faire.com/fastly/5b43adbdbd83c28aa3aad06e2c4c5c088a6557f0382f57893d43818e33b028cc.jpeg",
  ],
  priceDollars: 6.59,
  description:
    "\nOur Classic Shampoo is packed with 99% naturally derived ingredients that cleanse and nourish for ultimate shine and hair health. Specifically formulated with coconut, avocado and sunflower to gently rinse away dirt, grease and whatever else might dull your shine to help give you clean, soft, effortlessly awesome hair. Scented with our Food-Grade Fragrance Classic Coconut, you'll be transported somewhere tropical, every time you lather.\n",
  tags: [],
  msrpDollars: 11.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:47.180Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
